export default {
  'intl': 'https://x.com/nuinalp',
  'pt-br': 'https://x.com/nuinalp'
} as const;